const picUrl = "https://ghhd.ecnu.edu.cn/";

export default picUrl;
